import { Component } from '@angular/core';

@Component({
  selector: 'wsb-sms-adv-list',
  templateUrl: './sms-adv-list.component.html',
  styleUrls: ['./sms-adv-list.component.scss'],
  standalone: false
})
export class SmsAdvListComponent {
  activeId = 1;
  constructor() {}
}
